import { render, staticRenderFns } from "./areaSelect.vue?vue&type=template&id=35c9907e&scoped=true&"
import script from "./areaSelect.vue?vue&type=script&lang=js&"
export * from "./areaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9907e",
  null
  
)

export default component.exports